import React from 'react';
import { Link } from 'react-router-dom';

const StartBtn = ({ start, gameFlag }) => {
  return (
    <div className='start-container'>
      <Link to='/map-quiz'>
        <div className='start-btn' onClick={() => start()}>
          {gameFlag}
        </div>
      </Link>
    </div>
  );
};

export default StartBtn;
